<template>
  <svg  :class="{
          svg: true,
          [`svg--${name}`]: name,
        }">
    <use :xlink:href="`${icons}#${name}`"></use>
  </svg>
</template>

<script>

import icons from './icons.svg'

export default {
  props: {
    name: String,
  },
  setup() {

    return {
      icons,
    }
  }
}

</script>

<style scoped>

  .svg {
    align-items: center;
    display: inline-flex;
    justify-content: center;

    vertical-align: middle;

    width: 45px;
    height: 45px;
  }

</style>